var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardAmountInvested(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#FFF3EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.04 26.55C30.62 26.96 30.38 27.55 30.44 28.18C30.53 29.26 31.52 30.05 32.6 30.05H34.5V31.24C34.5 33.31 32.81 35 30.74 35H19.26C17.19 35 15.5 33.31 15.5 31.24V24.51C15.5 22.44 17.19 20.75 19.26 20.75H30.74C32.81 20.75 34.5 22.44 34.5 24.51V25.95H32.48C31.92 25.95 31.41 26.17 31.04 26.55Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 25.4093V20.8394C15.5 19.6494 16.23 18.5893 17.34 18.1693L25.28 15.1693C26.52 14.6993 27.85 15.6194 27.85 16.9494V20.7493",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5588 26.9692V29.0292C35.5588 29.5792 35.1188 30.0292 34.5588 30.0492H32.5988C31.5188 30.0492 30.5288 29.2592 30.4388 28.1792C30.3788 27.5492 30.6188 26.9592 31.0388 26.5492C31.4088 26.1692 31.9188 25.9492 32.4788 25.9492H34.5588C35.1188 25.9692 35.5588 26.4192 35.5588 26.9692Z",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25H27",
    stroke: "#E9690C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardAmountInvested);
export default __webpack_public_path__ + "static/media/dashboard-amount-invested.69e1750c670c8beb48621f35070c8365.svg";
export { ForwardRef as ReactComponent };